import { CalendarItemsColor } from 'theme/tokens';

import { WorkCalendarRecord } from '../types';
import { DayInfoItem } from '../ui/Calendar/Day';

interface GetAvailabilityInfoItemsParams {
    workCalendarRecord: WorkCalendarRecord;
    availableText: string;
    unavailableText: string;
}

export function getAvailabilityInfoItems({
    workCalendarRecord,
    availableText,
    unavailableText
}: GetAvailabilityInfoItemsParams): DayInfoItem[] {
    const { status, timeSlots } = workCalendarRecord;

    switch (status) {
        case 'Partial':
            return (timeSlots || [])
                .map(slot => ({
                    text: `${ formatTimeSlotTimePart(slot.startTimeTz) } - ${ formatTimeSlotTimePart(slot.finishTimeTz) }`,
                    color: CalendarItemsColor.available,
                    startTimeTz: slot.startTimeTz
                }));
        case 'Available':
            return [ {
                text: availableText,
                color: CalendarItemsColor.available
            } ];
        case 'Unavailable':
            return [ {
                text: unavailableText,
                color: CalendarItemsColor.unavailable
            } ];
        default:
            return [ ];
    }
}

function formatTimeSlotTimePart(timePart: string): string {
    const parts = timePart.split(':');

    return parts.slice(0, 2).join(':');
}
